<template>
  <v-container>
    <v-row v-if="statusType !== 'expired'" align="center">
      <span class="icon-wrapper">
        <div v-if="!hideMessage">{{ message }}</div>
        <!-- Icono con Tooltip -->
        <v-tooltip
          v-if="
            from === 'NotificationsList' ||
            from === 'NotificationPropertiesCard'
          "
          top
          content-class="tooltip-disclaimer"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              :class="from === 'NotificationsList' ? 'ml-1' : 'ml-0 mr-2 mb-1'"
              :color="icon?.color"
              :size="from === 'NotificationsList' ? 20 : 25"
            >
              {{ icon?.name }}
            </v-icon>
          </template>
          <span v-html="tooltipDisclaimer()"></span>
        </v-tooltip>
      </span>
      {{ days }} {{ wordString.day }} {{ hours }}h {{ ' ' + minutes }}m{{
        ' ' + seconds
      }}s
    </v-row>

    <v-row v-if="statusType === 'expired'">
      <div>{{ statusText }}</div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: ['starttime', 'endtime', 'hideMessage', 'from'],
  data: function () {
    return {
      timer: '',
      wordString: {},
      start: '',
      end: '',
      interval: '',
      days: '',
      minutes: '',
      hours: '',
      seconds: '',
      message: '',
      statusType: '',
      statusText: '',
      //
      icon: {
        name: 'mdi-alert',
        color: 'error',
      },
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.initCounter()
    },
  },
  mounted() {
    this.initCounter()
  },
  methods: {
    initCounter: function () {
      this.wordString = {
        day: this.$t('timer.day'),
        hours: this.$t('timer.hours'),
        minutes: this.$t('timer.minutes'),
        seconds: this.$t('timer.seconds'),
        expired: this.$t('timer.expired'),
        running: this.$t('timer.running'),
        upcoming: this.$t('timer.upcoming'),
        status: {
          expired: this.$t('timer.status.expired'),
          running: this.$t('timer.status.running'),
          upcoming: this.$t('timer.status.upcoming'),
        },
      }

      this.start = new Date(this.starttime).getTime()
      this.end = new Date(this.endtime).getTime()
      // Update the count down every 1 second
      this.timerCount(this.start, this.end)
      this.interval = setInterval(() => {
        this.timerCount(this.start, this.end)
      }, 1000)
    },
    timerCount: function (start, end) {
      // Get todays date and time
      var now = new Date().getTime()

      // Find the distance between now an the count down date
      var distance = start - now
      var passTime = end - now

      if (distance < 0 && passTime < 0) {
        this.message = this.wordString.expired
        this.statusType = 'expired'
        this.statusText = this.wordString.status.expired
        clearInterval(this.interval)
        return
      } else if (distance < 0 && passTime > 0) {
        this.calcTime(passTime)
        this.message = this.wordString.running
        this.statusType = 'running'
        this.statusText = this.wordString.status.running
      } else if (distance > 0 && passTime > 0) {
        this.calcTime(distance)
        this.message = this.wordString.upcoming
        this.statusType = 'upcoming'
        this.statusText = this.wordString.status.upcoming
      }
    },
    calcTime: function (dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24))
      this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60))
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000)
    },
    tooltipDisclaimer() {
      // Mostrar en un tooltip multilinea
      const line1 = this.$t('disclaimerExpiration.listAndDetail.line1')
      const line2 = this.$t('disclaimerExpiration.listAndDetail.line2')
      const line3 = this.$t('disclaimerExpiration.listAndDetail.line3')
      const line4 = this.$t('disclaimerExpiration.listAndDetail.line4')
      const line5 = this.$t('disclaimerExpiration.listAndDetail.line5')

      // Unir las lineas con saltos de linea para mostrar un tooltip multilinea
      return `
        <div style="padding: 6px 8px; margin-top: 4px; text-align: center;">
          ${line1}<br>
          ${line2}<br>
          ${line3}
        </div>
        <div style="border: 1px solid; border-radius: 4px; padding: 6px 8px; margin-top: 6px; background-color: #b03936">          
          <span style="color: #ffffff; font-weight: bold; font-size: 1.1em; display: block;">${line4}</span>
          <span style="color: #ffffff; font-weight: bold; font-size: 1.1em; display: block;">${line5}</span>
        </div>
      `
    },
  },
}
</script>

<style lang="scss" scoped>
/* tooltip de disclaimer: color fondo personalizado y eliminar la transparencia */
.tooltip-disclaimer {
  background-color: rgba(97, 97, 97, 1) !important; /* opaco */
  opacity: 1 !important; /* sin transparencia */
  color: #ffffff; /* texto base legible */
}

.icon-wrapper {
  display: inline-flex;
  align-items: center;
}
</style>
